
export default function Business() {

    return (
        <div>
            <section className="horizon_half" style={{minHeight: 'calc(100vh - 194px)'}}>
                    <div className="nv_contents_search nv_contents_search_type2 nv_tit_search">
                        <h2>협력업체 정보</h2>
                        <div className="search_wrap">
                            <p className="m_tit nv_bold pc_skip tpc_skip">기간 설정</p>
                            <div className="nv_date_box">
                                <span className="icon_date">달력 아이콘</span>
                                <input type="text" className="nv_input" id="datepicker"/>
                                    <span>~</span>
                                <input type="text" className="nv_input" id="datepicker2"/>
                            </div>
                            <p className="m_tit nv_bold pc_skip tpc_skip">검색 조건</p>
                            <div className="nv_select_box">
                                <p id="businessConditionKey">방문자</p>
                                <ul>
                                    <li>방문자</li>
                                    <li>업체명</li>
                                    <li>연락처</li>
                                </ul>
                            </div>
                            <div className="nv_search_box">
                                <input type="text" id="businessSearchVal" className="nv_input"/>
                                <button type="button" id="businessSearchBtn" className="nv_search_icon">검색</button>
                            </div>
                        </div>
                    </div>
                    <div className="nv_table_box">
                        <table id="businessTable" className="nv_table textcenter">
                            <colgroup>
                                <col/><col/><col/><col/><col/><col/><col/><col/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th scope="row" className="nv_gray_check">
                                    <input type="checkbox" id="allcheck"/>
                                        <label htmlFor="allcheck">전체 선택</label>
                                </th>
                                <th scope="row">이름</th>
                                <th scope="row">업체명</th>
                                <th scope="row">연락처</th>
                                <th scope="row" className="tpc_skip m_skip">업체구분</th>
                                <th scope="row" className="tpc_skip m_skip">E-Mail</th>
                                <th scope="row" className="tpc_skip m_skip">등록일</th>
                                <th scope="row">비고</th>
                            </tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                    </div>
                    <div className="nv_m_btn_area nv_bord_btn_area justify_btn_area"
                         style={{overflowX:'auto', boxSizing:'border-box'}}>
                        <button type="button" id="businessRegistDelBtn" className="nv_red_button left">- 선택 삭제</button>
                        <div id="pagenation1" className="nv_table_pagenum">
                            <ul>
                                <li className="first">처음으로</li>
                                <li className="prev">이전으로</li>
                                <li className="on">1</li>
                                <li className="next">다음으로</li>
                                <li className="last">마지막으로</li>
                            </ul>
                        </div>
                        <button type="button" className="nv_blue_button right toggle_btn off nv_modal1_open">+ 업체 등록
                        </button>
                    </div>
                </section>
                <section className="horizon_half" style={{minHeight: 'calc(100vh - 194px)'}}>
                    <div className="nv_contents_search nv_contents_search_type2 nv_tit_search">
                        <h2>협력업체 출입정보</h2>
                        <div className="search_wrap">
                            <p className="m_tit nv_bold pc_skip tpc_skip">기간 설정</p>
                            <div className="nv_date_box">
                                <span className="icon_date">달력 아이콘</span>
                                <input type="text" className="nv_input" id="datepicker3"/>
                                    <span>~</span>
                                    <input type="text" className="nv_input" id="datepicker4"/>
                            </div>
                            <p className="m_tit nv_bold pc_skip tpc_skip">검색 조건</p>
                            <div className="nv_select_box">
                                <p id="inoutConditionKey">방문자</p>
                                <ul>
                                    <li>방문자</li>
                                    <li>업체명</li>
                                    <li>연락처</li>
                                </ul>
                            </div>
                            <div className="nv_search_box">
                                <input type="text" id="inoutSearchVal" className="nv_input"/>
                                    <button type="button" id="inoutSearchBtn" className="nv_search_icon">검색</button>
                            </div>
                        </div>
                    </div>
                    <div className="nv_table_box">
                        <table id="inoutTable" className="nv_table textcenter">
                            <thead>
                            <tr>
                                <th scope="row">이름</th>
                                <th scope="row">업체명</th>
                                <th scope="row">연락처</th>
                                <th scope="row" className="m_skip tpc_skip">업체구분</th>
                                <th scope="row" className="m_skip tpc_skip">방문시작일</th>
                                <th scope="row" className="m_skip tpc_skip">방문종료일</th>
                                <th scope="row">방문증번호</th>
                                <th scope="row">비고</th>
                            </tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                    </div>
                    <div className="nv_m_btn_area nv_bord_btn_area justify_btn_area emtpy"
                         style={{overflowX:'auto', boxSizing:'border-box'}}>
                        <div id="pagenation2" className="nv_table_pagenum">
                            <ul>
                                <li className="first">처음으로</li>
                                <li className="prev">이전으로</li>
                                <li className="on">1</li>
                                <li className="next">다음으로</li>
                                <li className="last">마지막으로</li>
                            </ul>
                        </div>
                        <button type="button" className="nv_blue_button right toggle_btn off nv_modal3_open">+ 출입 등록
                        </button>
                    </div>
                </section>
        </div>
    )
}